import React  from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import Input from "../../../../../../../core/gd-form/form-element/input/input"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"

type Props = {
    form: FormManager
}

export default function ViewName(props: Props) {
    return (
        <div className="row">
            <div className="label">Name</div>
            <div className="element">
                <Input className="w-100-percent"
                       size="big"
                       form={props.form}
                       name="name"/>
                <FormError form={props.form} name="name" />
            </div>
        </div>
    )
}